/**
 * Admin callable helpers for bulk user actions.
 */

import {httpsCallable} from "firebase/functions";
import {functions} from "../app/firebase";

const MAX_USER_IDS = 20;

/**
 * Permanently delete users (Firestore + Storage + Auth) via Cloud Function.
 * @param {string[]} userIds
 * @returns {Promise<{ results: Array<{ userId: string, ok: boolean, error?: string }> }>}
 */
export async function adminDeleteUsers(userIds) {
  if (!Array.isArray(userIds) || userIds.length === 0) {
    throw new Error("userIds array is required");
  }
  if (userIds.length > MAX_USER_IDS) {
    throw new Error(`At most ${MAX_USER_IDS} users per request`);
  }

  const callable = httpsCallable(functions, "adminDeleteUsers");
  const result = await callable({userIds});
  return result.data;
}
